import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" style={{ marginTop: '20px', marginBottom: '40px' }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Política de Privacidade
      </Typography>
      <Typography variant="body1" paragraph>
        Esta política de privacidade cobre o blog Fé Escrita (feescrita.com) e o aplicativo
        móvel Fé Escrita (iOS e Android). Respeitamos sua privacidade e estamos comprometidos
        em proteger suas informações pessoais.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom style={{ marginTop: '24px' }}>
        Blog (feescrita.com)
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Coleta de informações</strong>: coletamos informações que você nos fornece
        diretamente, como quando se inscreve em nossa newsletter ou envia um comentário.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Uso de informações</strong>: usamos as informações coletadas para melhorar
        nossos serviços, enviar atualizações e personalizar a experiência dos usuários no blog.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Cookies</strong>: utilizamos cookies para personalizar o conteúdo e analisar o
        tráfego no site. Você pode desativar os cookies ajustando as configurações do seu
        navegador.
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom style={{ marginTop: '24px' }}>
        Aplicativo móvel (iOS e Android)
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Login</strong>: o app permite entrar com Google ou Apple. Coletamos seu
        endereço de e-mail para autenticação. O login é opcional — o diário funciona
        localmente no aparelho sem login.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Diário espiritual</strong>: se você estiver logado, as entradas do seu diário
        são salvas de forma segura (via Supabase) para sincronizar entre dispositivos. Sem
        login, o diário fica salvo apenas localmente no aparelho.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Chat de oração com IA</strong>: o texto que você digita nesse recurso é
        enviado ao nosso servidor e processado pela OpenAI apenas para gerar a resposta.
        Esse texto não é armazenado após a resposta ser gerada e não é vinculado ao seu
        perfil.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Compras dentro do app</strong>: assinaturas Premium são processadas pela
        RevenueCat e pela loja de aplicativos (App Store / Google Play). Não temos acesso a
        dados de cartão de crédito.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Retenção e exclusão de dados</strong>: dados da conta e do diário são
        mantidos enquanto sua conta existir. Você pode solicitar a exclusão completa e
        imediata dos seus dados a qualquer momento em Perfil {'>'} Apagar minha conta e dados,
        dentro do app.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Público-alvo</strong>: o app é destinado a adultos e adolescentes a partir de
        13 anos, e não é direcionado a crianças.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Publicidade</strong>: o aplicativo móvel não exibe anúncios nem usa redes de
        publicidade.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Segurança</strong>: todas as comunicações do app usam HTTPS/TLS. Nenhum
        método de transmissão de dados na internet é completamente seguro, mas adotamos
        medidas para proteger suas informações contra acessos não autorizados.
      </Typography>

      <Box style={{ marginTop: '24px' }}>
        <Typography variant="body1" paragraph>
          <strong>Alterações nesta política</strong>: podemos alterar esta política
          periodicamente. Recomendamos revisar esta página regularmente.
        </Typography>
        <Typography variant="body1">
          Para mais informações ou para solicitar a exclusão dos seus dados, entre em contato
          pelo e-mail{' '}
          <a href="mailto:feescrita@gmail.com">feescrita@gmail.com</a>.
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
